package com.rainbowclubs.rainbow.presentation

sealed class ScreenState<out T> {
    object Loading : ScreenState<Nothing>()
    class Content<T>(val data: T) : ScreenState<T>()
    class Error(val e: Throwable) : ScreenState<Nothing>()
}